export function toUrl(url: string) {
  window.location.assign(url);
}

export function withTvsState(baseUrl: string, state: string): string {
  const url = new URL(baseUrl);
  url.searchParams.set('tvs_state', state);
  return url.toString();
}
